import { wtUserApi } from 'api/clients';

import type { GenericResponse } from 'commons/modules/generic-response';

import {
  ApiResponse,
  adaptApiToGenericResponse,
  adaptErrorToGenericResponse,
} from '../shared';

import type { OfficeDataDto } from './dto';
import { mapOfficeDataDtoToModel } from './mappers';
import type { OfficeData } from './models';

const mapOfficeResponseToApiResponse = (
  response: ApiResponse<OfficeDataDto>,
): ApiResponse<OfficeData> => ({
  ...response,
  pagination: null,
  data: mapOfficeDataDtoToModel(response.data),
});

export const getOfficeById = async (
  investmentOfficeId: string,
): Promise<GenericResponse<ApiResponse<OfficeData>>> => {
  try {
    const response = await wtUserApi.get<ApiResponse<OfficeDataDto>>(
      '/management/offices/id',
      {
        params: {
          investmentOfficeId,
        },
      },
    );

    const mappedResponse = mapOfficeResponseToApiResponse(response.data);

    return adaptApiToGenericResponse(mappedResponse, response.status);
  } catch (error: any) {
    return adaptErrorToGenericResponse(
      error,
      'Ocurrió un error al obtener la oficina',
    );
  }
};

export const updateImageInvestmentOfficeId = async (
  file: File,
  investmentOfficeId: string,
): Promise<GenericResponse<ApiResponse<OfficeData>>> => {
  const formData = new FormData();
  const form = JSON.stringify({ investmentOfficeId });
  const blob = new Blob([form], {
    type: 'application/json',
  });
  formData.append('data', blob);
  formData.append('file', file);

  try {
    const response = await wtUserApi.post<ApiResponse<OfficeDataDto>>(
      '/management/offices/image',
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    );

    const mappedResponse = mapOfficeResponseToApiResponse(response.data);

    return adaptApiToGenericResponse(mappedResponse, response.status);
  } catch (error: any) {
    return adaptErrorToGenericResponse(
      error,
      'Ocurrió un error al obtener al actualizar la imagen',
    );
  }
};

export const updateGlobalOfficeInformation = async (
  request: OfficeData,
): Promise<GenericResponse<ApiResponse<OfficeData>>> => {
  try {
    const response = await wtUserApi.put<ApiResponse<OfficeDataDto>>(
      '/management/offices',
      request,
    );

    const mappedResponse = mapOfficeResponseToApiResponse(response.data);

    return adaptApiToGenericResponse(mappedResponse, response.status);
  } catch (error: any) {
    return adaptErrorToGenericResponse(
      error,
      'Ocurrió un error al actualizar la información',
    );
  }
};
